import { RSAA } from 'redux-api-middleware';

// Constants
export const REPORTS_IS_FETCHING = 'REPORTS_IS_FETCHING';
export const REPORTS_GET_SUCCESS = 'REPORTS_GET_SUCCESS';
export const REPORTS_GET_ERROR = 'REPORTS_GET_ERROR';
export const REPORTS_SET_CURRENT_PAGE = 'REPORTS_SET_CURRENT_PAGE';
export const REPORTS_DOWNLOAD_START = 'REPORTS_DOWNLOAD_START';
export const REPORTS_DOWNLOAD_END = 'REPORTS_DOWNLOAD_END';

// Initial State
export const initialState = {
  defaultSearchParams: {
    perPage: 25,
    page: 1
  },
  sorting: {
    prop: '',
    direction: ''
  },
  pagination: {
    page: 1,
    total: 0
  },
  isFetching: false,
  items: [],
  selectedItem: null,
  error: null,
  inDownload: ''
};

// Actions
export const getReportList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_REPORT',
      controlAction: 'collection',
      queryString: {
        ...queryString,
        page: queryString.page ? queryString.page : 1,
        perPage: queryString.perPage ? queryString.perPage : 25,
        year: queryString.year ? queryString.year : '',
        month: queryString.month ? queryString.month : '',
        orderBy: queryString.orderBy ? queryString.orderBy : ''
      },
      types: [
        REPORTS_IS_FETCHING,
        {
          type: REPORTS_GET_SUCCESS,
          meta: { ...queryString }
        },
        REPORTS_GET_ERROR
      ]
    }
  };
};

export const startDownload = () => {
  return dispatch => {
    dispatch({ type: REPORTS_DOWNLOAD_START });
  };
};

export const stopDownload = () => {
  return dispatch => {
    dispatch({ type: REPORTS_DOWNLOAD_END });
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case REPORTS_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case REPORTS_DOWNLOAD_START:
      return { ...state, isFetching: true, error: null, inDownload: 'DOWNLOADING REPORT' };

    case REPORTS_DOWNLOAD_END:
      return { ...state, isFetching: false, error: null, inDownload: '' };

    case REPORTS_GET_SUCCESS:
      let prop, direction;
      if (action.meta.orderBy) {
        let splitted = action.meta.orderBy.split(':');
        prop = splitted[0];
        if (prop === state.sorting.prop) {
          direction = splitted[1];
        } else {
          direction = 'asc';
        }
      } else {
        prop = '';
      }
      direction = direction === 'asc' ? ':desc' : ':asc';

      return {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload.items,
        pagination: {
          ...state.pagination,
          page: +action.meta.page,
          total: Math.ceil(action.payload.totalCount / action.payload.perPage)
        },
        sorting: {
          ...state.sorting,
          prop: prop,
          direction: direction
        },
        searchParams: {
          year: action.meta.year,
          month: action.meta.month
        }
      };

    case REPORTS_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    case REPORTS_SET_CURRENT_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          current: Number(action.page)
        }
      };
    default:
      return state;
  }
};
